/* eslint-disable no-dupe-keys */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const LMT_ENHCMT_bsOnlineTxn_API_CALL = createAsyncThunk(
  'LMT_ENHCMT_bsOnlineTxn_API_CALL',
  async (object, { getState, rejectWithValue, dispatch }) => {
    dispatch({ type: 'LMT_ENHCMT_bsOnlineTxn_API_CALL/pending', payload: {} });
    SecureClient({
      isEncrypted: false,
      customerId: null,
      route: 'perfiosforweb',
      payload: {
        proofId: 1,
        requestType: 'SAVE_BANK_STATEMENT',
        filePath: ['1/1421979341/30052022/1653879069.pdf'],
        bankStatement: {
          instiId: 135,
          bankName: 'KotakMahindraBankLimited',
          bankId: 1,
        },
        customerRefNum: '27577827uxlgbf',
        journeyType: 'LIMIT_ENHANCE',
        Password: 'abc',
        journeyType: 'KYC',
      },
      otherPayloadDetailsPresent: false,
      headers: { authorization: null, customerid: null },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const bankInfoDetails = res && res.body && res.body.bankInfoDetails;
        dispatch({
          type: 'LMT_ENHCMT_bsOnlineTxn_API_CALL/fulfilled',
          payload: bankInfoDetails,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({
          type: 'LMT_ENHCMT_bsOnlineTxn_API_CALL/rejected',
          payload: err,
        });
      },
    });
  }
);

export const LMT_ENHCMT_bsOnlineTxn_API_CALL_extrareducer = {
  [LMT_ENHCMT_bsOnlineTxn_API_CALL.pending]: (state, action) => {
    state.bsOnlineTxnAPICall.isLoading = true;
  },
  [LMT_ENHCMT_bsOnlineTxn_API_CALL.fulfilled]: (state, action) => {
    state.bsOnlineTxnAPICall.isLoading = false;

    state.bsOnlineTxnAPICall.isSuccess = true;
    state.bsOnlineTxnAPICall.isError = false;
    state.bsOnlineTxnAPICall.response = action.payload;
  },
  [LMT_ENHCMT_bsOnlineTxn_API_CALL.rejected]: (state, action) => {
    state.bsOnlineTxnAPICall.isLoading = false;

    state.bsOnlineTxnAPICall.isSuccess = false;
    state.bsOnlineTxnAPICall.isError = true;
    state.bsOnlineTxnAPICall.response = action.payload;
  },
};
